import { useCallback, useEffect, useState } from "react";
import { TenantService } from "@propertelligent/client-api";
import apiHelper from "../../utils/apiHelper";

export const useTenantData = (tenantId: number) => {
  const [tenantData, setTenantData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const fetchTenantData = useCallback(async () => {
    if (!tenantId) return;
    try {
      setLoading(true);
      const res: any = await apiHelper(
        TenantService.getApiTenant1,
        { showNotification: false },
        tenantId
      );
      setTenantData(res?.data?.success ?? null);
    } catch (err) {
      console.error("Error fetching tenant data:", err);
    } finally {
      setLoading(false);
    }
  }, [tenantId]);

  useEffect(() => {
    fetchTenantData();
  }, [fetchTenantData]);

  return { tenantData, loading, refetchTenantData: fetchTenantData };
};
